export default __webpack_public_path__ + "static/media/Robert_weapon.8c421eb6.png";